/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestMapleV2ProxyFactory extends Contract<ITestMapleV2ProxyFactory> {
  isInstance: Call<(instance_: AddressLike) => boolean, ITestMapleV2ProxyFactory>
  'isInstance(address)': Call<(instance_: AddressLike) => boolean, ITestMapleV2ProxyFactory>
}

let ITestMapleV2ProxyFactoryBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestMapleV2ProxyFactoryBytecode = '0x';
}

// prettier-ignore
export const ITestMapleV2ProxyFactory = contract<ITestMapleV2ProxyFactory>(ITestMapleV2ProxyFactoryBytecode)`
  function isInstance(address instance_) view returns (bool isInstance_)
`;